module.exports = __webpack_public_path__ + "static/Wuerttemberg2-scaled-eb81dde88806340ab0f18d63922dc0d1.jpeg";